import { authFetch } from 'auth/utils';
import { envVariables } from 'src/common/utils/envVariables';

const BASE_URL = `${envVariables.VITE_SIM_INVENTORY_BASE_API}/api/v1/subscription-status-reconciliations`;

export type ReconciliationHistoryEntry = {
  id: string;
  fileName: string;
  processedAt: string;
  processedBy: string;
  processedCount: number;
  skippedCount: number;
};

export type UploadReconciliationResponse = {
  processedCount: number;
  skippedCount: number;
};

export const uploadReconciliationFile = async (file: File): Promise<UploadReconciliationResponse> => {
  const data = new FormData();
  data.append('file', file, file.name);

  const response = await authFetch(BASE_URL, {
    method: 'POST',
    body: data,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text);
  }

  return response.json();
};

export const getReconciliationHistory = async (): Promise<ReconciliationHistoryEntry[]> => {
  const response = await authFetch(`${BASE_URL}/history`);

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
};
